import React from 'react';
import {getShortTimeAmPm} from '../../services/time-helpers.service';
import {Time} from '../../models/appointment.model';

interface TimeSelectorProps {
	availableTimes: Time[];
	selectedTime: Time;
	onSelectTime: (time: Time) => void;
}

const TimeSelector = ({availableTimes, selectedTime, onSelectTime}: TimeSelectorProps) => {
	return (
		<div className={`grid grid-cols-3 gap-2 mt-2`}>
			{availableTimes.map((item: Time) => (
				<button key={item.time}
				        className={`py-3 rounded-sm border ${selectedTime?.time === item?.time ? `border-primary bg-primary-10` : ''}`}
				        onClick={() => onSelectTime(item)}>
					{getShortTimeAmPm(item.time)}
				</button>
			))}
		</div>
	);
};

export default TimeSelector;
